import { useMemo } from "react"

export const useAllowedPaymentMethodTypes = (event) => {
  return useMemo(() => {
    if (event.onlinePaymentMethods === undefined) return undefined
    if (event.onlinePaymentMethods === null) return null

    if (
      event.onlinePaymentMethods?.length === 0 &&
      event.allowCreditCardPayments
    ) {
      return ["card"]
    }

    if (event.onlinePaymentMethods?.length === 0) {
      return []
    }

    return [...new Set([...event.onlinePaymentMethods, "card"])]
  }, [event.onlinePaymentMethods, event.allowCreditCardPayments])
}
